import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

export const servicesToAdd = [
  // Beauty Services
  {
    name: 'Bridal Makeup',
    description: 'Professional bridal makeup for your special day',
    longDescription: 'Complete bridal makeup package including hair styling, makeup application, and pre-bridal consultation. Our expert makeup artists use premium products to create your dream bridal look.',
    category: 'Beauty',
    price: 2999,
    originalPrice: 3999,
    duration: '3-4 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=800&q=80',
    features: ['Premium Products', 'Hair Styling Included', 'Trial Session', 'Touch-up Kit'],
    addons: [
      { id: '1', name: 'Pre-Bridal Skin Care Package', description: '3-day skin care routine before wedding', price: 1999, duration: '3 days' },
      { id: '2', name: 'False Eyelashes Premium', description: 'High-quality false eyelashes application', price: 499, duration: '15 min' },
      { id: '3', name: 'Airbrush Makeup Upgrade', description: 'Professional airbrush makeup for flawless finish', price: 799, duration: '30 min' }
    ],
    popular: true,
    new: false,
    featured: true
  },
  {
    name: 'Party Makeup',
    description: 'Glamorous makeup for parties and events',
    longDescription: 'Get party-ready with our professional makeup services. Perfect for cocktail parties, dinners, and special occasions.',
    category: 'Beauty',
    price: 1299,
    originalPrice: 1799,
    duration: '1-2 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?w=800&q=80',
    features: ['Professional Products', 'Long Lasting', 'Customized Look', 'Touch-ups'],
    addons: [
      { id: '1', name: 'Hair Styling', description: 'Professional hair styling for the party', price: 599, duration: '30 min' },
      { id: '2', name: 'False Lashes', description: 'False eyelashes application', price: 299, duration: '10 min' }
    ],
    popular: true,
    new: false,
    featured: false
  },
  {
    name: 'Hair Spa Treatment',
    description: 'Rejuvenating hair spa with deep conditioning',
    longDescription: 'Complete hair spa treatment including hair wash, deep conditioning, steam treatment, and head massage for healthy, shiny hair.',
    category: 'Beauty',
    price: 899,
    originalPrice: 1299,
    duration: '1.5 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&q=80',
    features: ['Deep Conditioning', 'Steam Treatment', 'Head Massage', 'Premium Products'],
    addons: [
      { id: '1', name: 'Hair Smoothing Treatment', description: 'Keratin-based hair smoothing for frizz-free hair', price: 1499, duration: '1 hour' },
      { id: '2', name: 'Scalp Treatment', description: 'Deep scalp nourishment and dandruff treatment', price: 699, duration: '30 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'Facial Treatment',
    description: 'Relaxing facial with natural products',
    longDescription: 'Professional facial treatment using natural and organic products. Includes cleansing, exfoliation, massage, and moisturizing.',
    category: 'Beauty',
    price: 799,
    originalPrice: 1199,
    duration: '1 hour',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80',
    features: ['Natural Products', 'Deep Cleansing', 'Face Massage', 'Moisturizing'],
    addons: [
      { id: '1', name: 'Gold Facial Upgrade', description: 'Premium gold facial for radiant skin', price: 999, duration: '30 min' },
      { id: '2', name: 'Under Eye Treatment', description: 'Special treatment for dark circles and puffiness', price: 499, duration: '20 min' }
    ],
    popular: true,
    new: false,
    featured: false
  },
  {
    name: 'Manicure & Pedicure',
    description: 'Complete hand and foot care treatment',
    longDescription: 'Pamper yourself with our professional manicure and pedicure services. Includes nail shaping, cuticle care, scrubbing, and polish.',
    category: 'Beauty',
    price: 699,
    originalPrice: 999,
    duration: '1 hour',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=800&q=80',
    features: ['Nail Shaping', 'Cuticle Care', 'Scrubbing', 'Polish Application'],
    addons: [
      { id: '1', name: 'Gel Polish Upgrade', description: 'Long-lasting gel polish application', price: 399, duration: '15 min' },
      { id: '2', name: 'Nail Art', description: 'Custom nail art design on all nails', price: 499, duration: '20 min' }
    ],
    popular: false,
    new: true,
    featured: false
  },

  // Home Care Services
  {
    name: 'Deep Home Cleaning',
    description: 'Thorough cleaning of your entire home',
    longDescription: 'Professional deep cleaning service covering all rooms, kitchen, bathrooms, and living areas. Includes dusting, mopping, and sanitization.',
    category: 'Home Care',
    price: 1499,
    originalPrice: 2199,
    duration: '4-6 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80',
    features: ['All Rooms', 'Kitchen Deep Clean', 'Bathroom Sanitization', 'Eco-friendly Products'],
    addons: [
      { id: '1', name: 'Balcony Cleaning', description: 'Complete balcony cleaning and washing', price: 399, duration: '30 min' },
      { id: '2', name: 'Window Cleaning', description: 'All windows inside and outside cleaning', price: 599, duration: '1 hour' },
      { id: '3', name: 'Sofa Shampooing', description: 'Deep shampooing for all sofas', price: 799, duration: '1 hour' }
    ],
    popular: true,
    new: false,
    featured: true
  },
  {
    name: 'Sofa Cleaning',
    description: 'Professional sofa and upholstery cleaning',
    longDescription: 'Deep cleaning of sofas and upholstery using advanced equipment. Removes stains, dirt, and allergens.',
    category: 'Home Care',
    price: 899,
    originalPrice: 1299,
    duration: '2-3 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=80',
    features: ['Stain Removal', 'Deep Cleaning', 'Sanitization', 'Quick Drying'],
    addons: [
      { id: '1', name: 'Scotchgard Protection', description: 'Protective coating to prevent future stains', price: 699, duration: '30 min' },
      { id: '2', name: 'Cushion Deep Clean', description: 'Remove and deep clean all cushion covers', price: 499, duration: '1 hour' }
    ],
    popular: true,
    new: false,
    featured: false
  },
  {
    name: 'Kitchen Cleaning',
    description: 'Complete kitchen deep cleaning service',
    longDescription: 'Thorough kitchen cleaning including chimney, stove, sink, cabinets, and all surfaces. Removes grease and grime effectively.',
    category: 'Home Care',
    price: 699,
    originalPrice: 999,
    duration: '2-3 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&q=80',
    features: ['Chimney Cleaning', 'Stove Cleaning', 'Cabinet Cleaning', 'Degreasing'],
    addons: [
      { id: '1', name: 'Refrigerator Deep Clean', description: 'Inside and outside refrigerator cleaning', price: 399, duration: '30 min' },
      { id: '2', name: 'Exhaust Fan Cleaning', description: 'Complete exhaust fan dismantling and cleaning', price: 299, duration: '20 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'Bathroom Cleaning',
    description: 'Deep cleaning and sanitization of bathrooms',
    longDescription: 'Professional bathroom cleaning including tiles, fixtures, toilet, and drainage. Complete sanitization for a hygienic bathroom.',
    category: 'Home Care',
    price: 499,
    originalPrice: 799,
    duration: '1-2 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80',
    features: ['Tile Cleaning', 'Fixture Polishing', 'Toilet Cleaning', 'Sanitization'],
    addons: [
      { id: '1', name: 'Anti-bacterial Treatment', description: 'Special anti-bacterial coating for bathroom', price: 399, duration: '15 min' },
      { id: '2', name: 'Drain Cleaning', description: 'Clear blocked drains and pipes', price: 299, duration: '20 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'Carpet Cleaning',
    description: 'Professional carpet and rug cleaning',
    longDescription: 'Deep carpet cleaning using professional equipment. Removes dirt, stains, and allergens leaving your carpets fresh and clean.',
    category: 'Home Care',
    price: 799,
    originalPrice: 1199,
    duration: '2-3 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    features: ['Deep Cleaning', 'Stain Removal', 'Allergen Removal', 'Fast Drying'],
    addons: [
      { id: '1', name: 'Carpet Protection Spray', description: 'Protective spray to repel stains and dirt', price: 599, duration: '20 min' },
      { id: '2', name: 'Deodorization', description: 'Professional deodorization for fresh smell', price: 399, duration: '15 min' }
    ],
    popular: false,
    new: true,
    featured: false
  },

  // Repair Services
  {
    name: 'Mobile Phone Repair',
    description: 'Expert repair for all mobile phone issues',
    longDescription: 'Professional mobile phone repair services including screen replacement, battery replacement, charging port repair, and software issues.',
    category: 'Repair',
    price: 599,
    originalPrice: 899,
    duration: '1-2 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=800&q=80',
    features: ['Screen Replacement', 'Battery Replacement', 'Charging Port Fix', 'Software Repair'],
    addons: [
      { id: '1', name: 'Tempered Glass Protection', description: 'Premium tempered glass screen protector', price: 299, duration: '5 min' },
      { id: '2', name: 'Phone Case', description: 'Protective phone case', price: 399, duration: '2 min' },
      { id: '3', name: 'Data Backup Service', description: 'Complete data backup before repair', price: 199, duration: '15 min' }
    ],
    popular: true,
    new: false,
    featured: false
  },
  {
    name: 'Laptop Repair',
    description: 'Complete laptop repair and servicing',
    longDescription: 'Professional laptop repair including hardware issues, software problems, virus removal, and performance optimization.',
    category: 'Repair',
    price: 799,
    originalPrice: 1299,
    duration: '2-4 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=800&q=80',
    features: ['Hardware Repair', 'Software Fix', 'Virus Removal', 'Performance Boost'],
    addons: [
      { id: '1', name: 'RAM Upgrade', description: 'Upgrade RAM up to 16GB', price: 2999, duration: '30 min' },
      { id: '2', name: 'SSD Installation', description: 'Replace HDD with faster SSD', price: 3999, duration: '1 hour' },
      { id: '3', name: 'Windows Installation', description: 'Fresh Windows OS installation', price: 599, duration: '1 hour' }
    ],
    popular: true,
    new: false,
    featured: true
  },
  {
    name: 'TV Repair',
    description: 'LED/LCD TV repair and maintenance',
    longDescription: 'Expert TV repair services for all brands. Includes screen issues, sound problems, and connectivity fixes.',
    category: 'Repair',
    price: 499,
    originalPrice: 799,
    duration: '1-3 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?w=800&q=80',
    features: ['Screen Repair', 'Sound Fix', 'Connectivity Issues', 'All Brands'],
    addons: [
      { id: '1', name: 'Wall Mounting', description: 'Professional TV wall mounting service', price: 799, duration: '1 hour' },
      { id: '2', name: 'HDMI Cable', description: 'High-quality HDMI cable (6 feet)', price: 299, duration: '5 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'Refrigerator Repair',
    description: 'Fridge repair and gas charging',
    longDescription: 'Professional refrigerator repair including cooling issues, gas charging, compressor problems, and thermostat replacement.',
    category: 'Repair',
    price: 699,
    originalPrice: 1099,
    duration: '2-3 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1571175443880-49e1d25b2bc5?w=800&q=80',
    features: ['Gas Charging', 'Cooling Fix', 'Compressor Repair', 'Thermostat Fix'],
    addons: [
      { id: '1', name: 'Deep Freezer Section Clean', description: 'Defrost and deep clean freezer section', price: 399, duration: '30 min' },
      { id: '2', name: 'Door Seal Replacement', description: 'Replace worn-out refrigerator door seal', price: 599, duration: '20 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'Washing Machine Repair',
    description: 'Washing machine repair and servicing',
    longDescription: 'Expert washing machine repair for all types. Includes motor issues, drainage problems, and spin cycle fixes.',
    category: 'Repair',
    price: 599,
    originalPrice: 999,
    duration: '1-2 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?w=800&q=80',
    features: ['Motor Repair', 'Drainage Fix', 'Spin Cycle', 'All Models'],
    addons: [
      { id: '1', name: 'Drum Cleaning', description: 'Deep cleaning of washing machine drum', price: 299, duration: '20 min' },
      { id: '2', name: 'Filter Replacement', description: 'Replace water inlet and outlet filters', price: 399, duration: '15 min' }
    ],
    popular: false,
    new: true,
    featured: false
  },

  // AC Repair Services
  {
    name: 'AC Installation',
    description: 'Professional air conditioner installation',
    longDescription: 'Expert AC installation service with proper mounting, gas filling, and testing. Includes free demo and usage guidance.',
    category: 'AC Repair',
    price: 1299,
    originalPrice: 1799,
    duration: '2-3 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1631545806609-450e4ef8de85?w=800&q=80',
    features: ['Professional Installation', 'Gas Filling', 'Testing', 'Usage Guidance'],
    addons: [
      { id: '1', name: 'Copper Piping Extended', description: 'Additional copper piping (per meter)', price: 299, duration: '15 min' },
      { id: '2', name: 'Stabilizer Installation', description: 'Voltage stabilizer for AC protection', price: 2499, duration: '30 min' },
      { id: '3', name: 'Drain Pipe Extended', description: 'Extended drain pipe for proper drainage', price: 199, duration: '20 min' }
    ],
    popular: true,
    new: false,
    featured: true
  },
  {
    name: 'AC Servicing',
    description: 'Complete AC servicing and maintenance',
    longDescription: 'Thorough AC servicing including filter cleaning, coil cleaning, gas check, and performance optimization.',
    category: 'AC Repair',
    price: 599,
    originalPrice: 899,
    duration: '1-2 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?w=800&q=80',
    features: ['Filter Cleaning', 'Coil Cleaning', 'Gas Check', 'Performance Check'],
    addons: [
      { id: '1', name: 'Jet Wash Service', description: 'High-pressure jet wash for outdoor unit', price: 499, duration: '30 min' },
      { id: '2', name: 'Anti-Rust Coating', description: 'Protective anti-rust coating for outdoor unit', price: 699, duration: '20 min' }
    ],
    popular: true,
    new: false,
    featured: false
  },
  {
    name: 'AC Gas Refilling',
    description: 'AC gas charging and leak repair',
    longDescription: 'Professional AC gas refilling service with leak detection and repair. Ensures optimal cooling performance.',
    category: 'AC Repair',
    price: 899,
    originalPrice: 1299,
    duration: '1-2 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1585314062340-f1a5a7c9328d?w=800&q=80',
    features: ['Gas Refilling', 'Leak Detection', 'Pressure Check', 'Cooling Test'],
    addons: [
      { id: '1', name: 'Leak Sealing', description: 'Seal detected leaks permanently', price: 799, duration: '30 min' },
      { id: '2', name: 'Vacuum Pump Service', description: 'Remove moisture and air from system', price: 599, duration: '20 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'AC Repair',
    description: 'Expert AC repair for all issues',
    longDescription: 'Complete AC repair service including compressor issues, cooling problems, noise reduction, and electrical fixes.',
    category: 'AC Repair',
    price: 799,
    originalPrice: 1199,
    duration: '2-3 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1607400201889-565b1ee75f8e?w=800&q=80',
    features: ['Compressor Fix', 'Cooling Issues', 'Noise Reduction', 'Electrical Repair'],
    addons: [
      { id: '1', name: 'PCB Repair', description: 'Repair or replace AC control board', price: 1499, duration: '1 hour' },
      { id: '2', name: 'Fan Motor Replacement', description: 'Replace faulty indoor or outdoor fan motor', price: 1999, duration: '1 hour' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'AC Uninstallation',
    description: 'Safe AC removal and uninstallation',
    longDescription: 'Professional AC uninstallation service with safe removal, gas recovery, and bracket removal.',
    category: 'AC Repair',
    price: 499,
    originalPrice: 799,
    duration: '1 hour',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1614098886339-21e9718de50c?w=800&q=80',
    features: ['Safe Removal', 'Gas Recovery', 'Bracket Removal', 'Clean Work'],
    addons: [
      { id: '1', name: 'Wall Repair & Painting', description: 'Repair holes and repaint wall after removal', price: 699, duration: '1 hour' },
      { id: '2', name: 'Gas Recovery Service', description: 'Safely recover gas for reuse', price: 399, duration: '15 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },

  // Cleaning Services
  {
    name: 'Full House Cleaning',
    description: 'Complete house cleaning service',
    longDescription: 'Comprehensive house cleaning including all rooms, kitchen, bathrooms, balconies, and windows. Professional team with eco-friendly products.',
    category: 'Cleaning',
    price: 1999,
    originalPrice: 2999,
    duration: '5-7 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?w=800&q=80',
    features: ['All Rooms', 'Kitchen & Bathroom', 'Windows', 'Eco-friendly'],
    addons: [
      { id: '1', name: 'Terrace Cleaning', description: 'Complete terrace/rooftop cleaning', price: 799, duration: '1 hour' },
      { id: '2', name: 'Pest Control Treatment', description: 'General pest control spray', price: 999, duration: '30 min' },
      { id: '3', name: 'Curtain Cleaning', description: 'All curtains dry cleaning', price: 1299, duration: '2 hours' }
    ],
    popular: true,
    new: false,
    featured: true
  },
  {
    name: 'Office Cleaning',
    description: 'Professional office cleaning service',
    longDescription: 'Complete office cleaning including workstations, meeting rooms, pantry, and washrooms. Flexible timing options.',
    category: 'Cleaning',
    price: 1499,
    originalPrice: 2199,
    duration: '3-5 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80',
    features: ['Workstation Cleaning', 'Meeting Rooms', 'Pantry', 'Washrooms'],
    addons: [
      { id: '1', name: 'Chair Shampooing', description: 'Deep clean all office chairs', price: 999, duration: '1 hour' },
      { id: '2', name: 'Sanitization Service', description: 'Complete office sanitization', price: 1299, duration: '1 hour' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'Window Cleaning',
    description: 'Professional window and glass cleaning',
    longDescription: 'Expert window cleaning service for spotless, streak-free windows. Includes frames, tracks, and glass surfaces.',
    category: 'Cleaning',
    price: 699,
    originalPrice: 999,
    duration: '2-3 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?w=800&q=80',
    features: ['Streak-free', 'Frame Cleaning', 'Track Cleaning', 'High Windows'],
    addons: [
      { id: '1', name: 'Sliding Door Glass', description: 'Clean all sliding door glass panels', price: 499, duration: '30 min' },
      { id: '2', name: 'Balcony Railing Clean', description: 'Clean and polish balcony railings', price: 399, duration: '20 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'Move-in/Move-out Cleaning',
    description: 'Deep cleaning for moving homes',
    longDescription: 'Thorough cleaning service perfect for moving in or out. Includes complete sanitization and deep cleaning of all areas.',
    category: 'Cleaning',
    price: 2499,
    originalPrice: 3499,
    duration: '6-8 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
    features: ['Deep Cleaning', 'Sanitization', 'All Areas', 'Move-ready'],
    addons: [
      { id: '1', name: 'Cabinet Inside Cleaning', description: 'Deep clean inside all cabinets', price: 999, duration: '2 hours' },
      { id: '2', name: 'Ceiling Fan Cleaning', description: 'Clean all ceiling fans thoroughly', price: 699, duration: '1 hour' }
    ],
    popular: true,
    new: false,
    featured: false
  },
  {
    name: 'Post-Construction Cleaning',
    description: 'Cleaning after renovation or construction',
    longDescription: 'Specialized cleaning service to remove construction dust, debris, and stains. Makes your space move-in ready.',
    category: 'Cleaning',
    price: 2999,
    originalPrice: 4499,
    duration: '8-10 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80',
    features: ['Dust Removal', 'Debris Cleanup', 'Stain Removal', 'Deep Cleaning'],
    addons: [
      { id: '1', name: 'Paint Stain Removal', description: 'Remove paint stains from floors and surfaces', price: 1299, duration: '2 hours' },
      { id: '2', name: 'Polish All Surfaces', description: 'Polish tiles, granite, and wooden surfaces', price: 1999, duration: '3 hours' }
    ],
    popular: false,
    new: true,
    featured: false
  },

  // Plumbing Services
  {
    name: 'Tap Repair & Installation',
    description: 'Tap and faucet repair services',
    longDescription: 'Professional tap repair and installation including fixing leaks, replacing washers, and installing new taps.',
    category: 'Plumbing',
    price: 299,
    originalPrice: 499,
    duration: '30 min - 1 hour',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800&q=80',
    features: ['Leak Fix', 'Washer Replacement', 'Installation', 'All Types'],
    addons: [
      { id: '1', name: 'Premium Tap Installation', description: 'Install high-end designer tap', price: 499, duration: '30 min' },
      { id: '2', name: 'Water Filter Attachment', description: 'Attach water purifier to tap', price: 399, duration: '20 min' }
    ],
    popular: true,
    new: false,
    featured: false
  },
  {
    name: 'Toilet Installation & Repair',
    description: 'Complete toilet plumbing services',
    longDescription: 'Expert toilet installation and repair including flush problems, leakage, and seat replacement.',
    category: 'Plumbing',
    price: 599,
    originalPrice: 899,
    duration: '1-2 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1585313647787-89baa53c8f35?w=800&q=80',
    features: ['Flush Repair', 'Leak Fix', 'Installation', 'Seat Replacement'],
    addons: [
      { id: '1', name: 'Concealed Flush Tank Installation', description: 'Install modern concealed flush system', price: 1999, duration: '2 hours' },
      { id: '2', name: 'Health Faucet Installation', description: 'Install or replace health faucet', price: 299, duration: '15 min' }
    ],
    popular: true,
    new: false,
    featured: true
  },
  {
    name: 'Drain Cleaning',
    description: 'Blocked drain and pipe cleaning',
    longDescription: 'Professional drain cleaning service to remove blockages in sinks, basins, and pipes using modern equipment.',
    category: 'Plumbing',
    price: 499,
    originalPrice: 799,
    duration: '1-2 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800&q=80',
    features: ['Blockage Removal', 'Pipe Cleaning', 'Modern Equipment', 'Quick Service'],
    addons: [
      { id: '1', name: 'CCTV Drain Inspection', description: 'Camera inspection to locate blockages', price: 999, duration: '30 min' },
      { id: '2', name: 'Anti-Roach Trap Installation', description: 'Install traps to prevent roaches from drains', price: 599, duration: '20 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'Water Tank Cleaning',
    description: 'Complete water tank cleaning service',
    longDescription: 'Thorough water tank cleaning and sanitization for clean, safe drinking water. Includes overhead and underground tanks.',
    category: 'Plumbing',
    price: 899,
    originalPrice: 1299,
    duration: '2-3 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80',
    features: ['Deep Cleaning', 'Sanitization', 'All Tank Types', 'Safe Water'],
    addons: [
      { id: '1', name: 'Tank Leak Sealing', description: 'Seal any leaks in water tank', price: 799, duration: '1 hour' },
      { id: '2', name: 'Overflow Pipe Installation', description: 'Install or repair overflow pipe', price: 499, duration: '30 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'Bathroom Fitting',
    description: 'Complete bathroom fitting installation',
    longDescription: 'Professional installation of bathroom fittings including shower, taps, basin, and accessories.',
    category: 'Plumbing',
    price: 799,
    originalPrice: 1199,
    duration: '2-4 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1584622781485-7e4b0eedc7aa?w=800&q=80',
    features: ['Shower Installation', 'Tap Fitting', 'Basin Setup', 'Accessories'],
    addons: [
      { id: '1', name: 'Rain Shower Installation', description: 'Install premium rain shower system', price: 1999, duration: '1 hour' },
      { id: '2', name: 'Towel Rod & Soap Holder', description: 'Install all bathroom accessories', price: 599, duration: '30 min' }
    ],
    popular: false,
    new: true,
    featured: false
  },

  // Electrical Services
  {
    name: 'Wiring & Rewiring',
    description: 'Complete electrical wiring services',
    longDescription: 'Professional electrical wiring and rewiring for homes and offices. Safe, certified electricians.',
    category: 'Electrical',
    price: 1999,
    originalPrice: 2999,
    duration: '4-8 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80',
    features: ['Complete Wiring', 'Safety Check', 'Certified Work', 'Warranty'],
    addons: [
      { id: '1', name: 'Distribution Board Upgrade', description: 'Install modern MCB distribution board', price: 2499, duration: '2 hours' },
      { id: '2', name: 'Earth Leakage Installation', description: 'Install ELCB for safety', price: 1999, duration: '1 hour' }
    ],
    popular: true,
    new: false,
    featured: true
  },
  {
    name: 'Fan Installation & Repair',
    description: 'Ceiling fan and exhaust fan services',
    longDescription: 'Professional installation and repair of ceiling fans, exhaust fans, and table fans. Includes balancing and speed control.',
    category: 'Electrical',
    price: 299,
    originalPrice: 499,
    duration: '30 min - 1 hour',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1622973537968-3a3f9a4d38d0?w=800&q=80',
    features: ['Installation', 'Repair', 'Balancing', 'Speed Control'],
    addons: [
      { id: '1', name: 'Regulator Installation', description: 'Install electronic fan regulator', price: 399, duration: '15 min' },
      { id: '2', name: 'Fan Capacitor Replacement', description: 'Replace faulty capacitor', price: 199, duration: '10 min' }
    ],
    popular: true,
    new: false,
    featured: false
  },
  {
    name: 'Light Fixture Installation',
    description: 'Installation of lights and fixtures',
    longDescription: 'Expert installation of lights, chandeliers, and electrical fixtures. Includes wiring and safety checks.',
    category: 'Electrical',
    price: 399,
    originalPrice: 699,
    duration: '1-2 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?w=800&q=80',
    features: ['Light Installation', 'Chandelier Setup', 'Wiring', 'Safety Check'],
    addons: [
      { id: '1', name: 'Dimmer Switch Installation', description: 'Install light dimmer switch', price: 499, duration: '20 min' },
      { id: '2', name: 'LED Bulbs Set', description: 'Set of 5 premium LED bulbs', price: 999, duration: '5 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'Switch & Socket Repair',
    description: 'Switch and socket installation/repair',
    longDescription: 'Professional repair and installation of switches, sockets, and electrical outlets. Safe and certified work.',
    category: 'Electrical',
    price: 199,
    originalPrice: 399,
    duration: '30 min - 1 hour',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=800&q=80',
    features: ['Switch Repair', 'Socket Installation', 'Safety Check', 'Quick Service'],
    addons: [
      { id: '1', name: 'USB Socket Installation', description: 'Install USB charging socket', price: 599, duration: '15 min' },
      { id: '2', name: 'Modular Switch Upgrade', description: 'Replace with premium modular switches', price: 799, duration: '30 min' }
    ],
    popular: false,
    new: false,
    featured: false
  },
  {
    name: 'MCB & Fuse Replacement',
    description: 'MCB and electrical panel services',
    longDescription: 'Professional MCB replacement, fuse box repair, and electrical panel maintenance for safe power distribution.',
    category: 'Electrical',
    price: 499,
    originalPrice: 799,
    duration: '1-2 hours',
    rating: 0,
    reviews: 0,
    reviewCount: 0,
    image: 'https://images.unsplash.com/photo-1621905252472-943afbb5826f?w=800&q=80',
    features: ['MCB Replacement', 'Fuse Box Repair', 'Panel Check', 'Safety Test'],
    addons: [
      { id: '1', name: 'Voltage Stabilizer Installation', description: 'Install whole-house voltage stabilizer', price: 3999, duration: '1 hour' },
      { id: '2', name: 'Surge Protector', description: 'Install surge protection device', price: 1499, duration: '30 min' }
    ],
    popular: false,
    new: true,
    featured: false
  }
];

export async function addAllServices() {
  try {
    console.log('Starting to add services...');
    const snapshot = await getDocs(collection(db, 'services'));
    const existingServices = snapshot.docs.map(doc => doc.data().name);
    console.log(`Found ${existingServices.length} existing services`);
    
    let added = 0;
    let skipped = 0;
    
    for (const service of servicesToAdd) {
      if (!existingServices.includes(service.name)) {
        await addDoc(collection(db, 'services'), {
          ...service,
          createdAt: new Date().toISOString(),
          isActive: true,
          showOnHomePage: service.popular || service.featured,
          showInPopularSection: service.popular,
          showInFeaturedSection: service.featured
        });
        console.log(`✅ Added: ${service.name} (${service.category})`);
        added++;
      } else {
        console.log(`⏭️  Skipped: ${service.name} (already exists)`);
        skipped++;
      }
    }
    
    console.log(`\n✨ Complete! Added ${added} services, Skipped ${skipped}`);
    return { success: true, added, skipped };
  } catch (error) {
    console.error('Error adding services:', error);
    return { success: false, error };
  }
}
